import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { LDateTime } from '@app/components/date/LDateTime';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { StationReportMatchResult } from '../../../station-reports.types';

export function UnverifiedMatchesTable({ data }: { data: StationReportMatchResult[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<StationReportMatchResult>($t, {
          accessor: (row) => row.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 100,
        }),
        createCustomIdColumn<StationReportMatchResult>($t, {
          accessor: (row) => row.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => row.matchedSchedule?.datetime || null,
          Cell: ({ row }) => {
            const matchedSchedule = row.original.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LDateTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.ltxMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
        },
      ]}
    />
  );
}
